import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Allahindluse järgi

  <span style="color:#85c1dc;">**FI:**</span>
  Alennuksen mukaan

  <span style="color:#85c1dc;">**RU:**</span>
  Максимальная скидка
*/
/* @__NO_SIDE_EFFECTS__ */
const m678 = msg(
  mf`Allahindluse järgi`,
  mf`Alennuksen mukaan`,
  mf`Максимальная скидка`,
)

export { m678 as 'w.saal.reasta.soodus' }